import c from '@/styles/InstagramArticlesList';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from '@/utils/cn';
import { getPropStylesFactory } from '@/utils/getPropStylesFactory';

export interface InstagramArticlesListArticleHeadlineProps extends ComponentProps<'h4'> {
  variant?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'primary'>;
  size?: ClassNameProp<'default'>;
}

export const InstagramArticlesListArticleHeadlineComponent: Component<InstagramArticlesListArticleHeadlineProps> = ({
  className,
  variant,
  colors,
  size,
  children,
  ...props
}) => {
  const getPropStyles = getPropStylesFactory(c);

  const variantClassName = getPropStyles('article_headline_variant', variant, 'default');
  const colorClassName = getPropStyles('article_headline_colors', colors, 'primary');
  const sizeClassName = getPropStyles('article_headline_size', size, 'default');

  const componentClassName = cn(variantClassName, colorClassName, sizeClassName, className);

  return (
    <h4 className={componentClassName} {...props}>
      {children}
    </h4>
  );
};
